export default function getTimeoutForAttempt(attempt) {
  if (attempt === 2) return 5 * 1000;
  if (attempt === 3) return 20 * 1000;
  if (attempt === 4) return 60 * 1000;
  if (attempt > 4) return 5 * 60 * 1000;
}
